import { useCallback, useState } from 'react';
import {
    readShowClientAliasPreference,
    writeShowClientAliasPreference,
} from '@/pages/components/account/gl-invoice/columnAliasDisplay';

/**
 * 页级「显示客户别名」开关（localStorage）+ 行级临时展开 key 集合。
 */
export function useShowClientAlias() {
    const [showClientAlias, setShowClientAliasState] = useState(readShowClientAliasPreference);
    const [revealedKeys, setRevealedKeys] = useState<Set<string>>(() => new Set());

    const setShowClientAlias = useCallback((on: boolean) => {
        setShowClientAliasState(on);
        writeShowClientAliasPreference(on);
        if (on) setRevealedKeys(new Set());
    }, []);

    const toggleRevealKey = useCallback((key: string) => {
        setRevealedKeys((prev) => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    }, []);

    const isAliasVisible = useCallback(
        (columnKey?: string | null) => {
            if (showClientAlias) return true;
            if (!columnKey) return false;
            return revealedKeys.has(columnKey);
        },
        [showClientAlias, revealedKeys],
    );

    return {
        showClientAlias,
        setShowClientAlias,
        revealedKeys,
        toggleRevealKey,
        isAliasVisible,
    };
}
